import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export const LayoutSpacerSmall = ({ children, className }) => {
    return _jsx("div", { className: clsx('space-y-2 sm:space-y-3', className), children: children });
};
//# sourceMappingURL=index.js.map